module.exports = __webpack_public_path__ + "img/line-brands.4c3164ce.svg";